module.exports = __webpack_public_path__ + "static/82-92213003fa84a7ab45d2feb2031970cd.png";